import api from './api'

export interface CyclingPreviewEmployee {
  employee_id: number
  employee_name: string
  points_before: number
  points_after: number
  decay_amount: number
}

export interface CyclingPreview {
  year: number
  total_employees: number
  employees: CyclingPreviewEmployee[]
}

export interface PointsCycling {
  id: number
  reference_year: number
  snapshot: {
    employee_id: number
    employee_name: string
    points_before: number
    points_after: number
  }[]
  applied_by: number
  applied_at: string
}

export const cyclingService = {
  /**
   * Get cycling preview (does not apply)
   */
  async preview(year: number): Promise<CyclingPreview> {
    const response = await api.get<CyclingPreview>('/points-cycling/preview/', {
      params: { year },
    })
    return response.data
  },

  /**
   * Apply decay (irreversible)
   */
  async apply(year: number): Promise<PointsCycling> {
    const response = await api.post<PointsCycling>('/points-cycling/apply/', { year })
    return response.data
  },

  /**
   * Get all cycling records
   */
  async getAll(): Promise<PointsCycling[]> {
    const response = await api.get<PointsCycling[]>('/points-cycling/')
    return response.data
  },

  /**
   * Get cycling by ID
   */
  async getById(id: number): Promise<PointsCycling> {
    const response = await api.get<PointsCycling>(`/points-cycling/${id}/`)
    return response.data
  },
}

export default cyclingService
